import { css, html, LitElement } from 'lit'
import { safeCustomElement } from '@/utilities/custom-element'
@safeCustomElement('mdc-accordion')
export class MdcAccordion extends LitElement {
  static styles = css`
		:host {
			display: block;
			font-family: var(--typography-font-family-sans);
		}

		.mdc-accordion {
			display: flex;
			flex-direction: column;
		}
	`

  render() {
    return html`
			<div class="mdc-accordion">
				<slot></slot>
			</div>
		`
  }
}
